import React from 'react';

export type DataTier = 'LIVE' | 'MODELLED' | 'SCENARIO' | 'SYSTEM' | 'BACKUP';

const tierStyles: Record<
  DataTier,
  { label: string; border: string; bg: string; text: string; dot: string }
> = {
  LIVE: {
    label: 'LIVE',
    border: 'border-emerald-400/30',
    bg: 'bg-emerald-500/10',
    text: 'text-emerald-200',
    dot: 'bg-emerald-400',
  },
  MODELLED: {
    label: 'MODELLED',
    border: 'border-blue-400/30',
    bg: 'bg-blue-500/10',
    text: 'text-blue-200',
    dot: 'bg-blue-400',
  },
  SCENARIO: {
    label: 'SCENARIO',
    border: 'border-purple-400/30',
    bg: 'bg-purple-500/10',
    text: 'text-purple-200',
    dot: 'bg-purple-400',
  },
  SYSTEM: {
    label: 'SYSTEM',
    border: 'border-gray-400/30',
    bg: 'bg-gray-500/10',
    text: 'text-gray-200',
    dot: 'bg-gray-400',
  },
  BACKUP: {
    label: 'BACKUP',
    border: 'border-amber-400/40',
    bg: 'bg-amber-500/15',
    text: 'text-amber-200',
    dot: 'bg-amber-400',
  },
};

export interface DataBadgeProps {
  tier: DataTier;
  label?: string;
  title?: string;
  className?: string;
  showDot?: boolean;
}

const DataBadge: React.FC<DataBadgeProps> = ({
  tier,
  label,
  title,
  className = '',
  showDot = true,
}) => {
  const style = tierStyles[tier];
  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold tracking-wide ${style.border} ${style.bg} ${style.text} ${className}`}
    >
      {showDot && <span className={`h-1.5 w-1.5 rounded-full ${style.dot}`} />}
      <span>{label || style.label}</span>
    </span>
  );
};

export default DataBadge;

